import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ToolsService } from '@/services/tools-service/tools-service';
import { AbstractModel, Disposable } from '@patsnap/tahiti-core';
import type { ToolMenuItem } from '@/types';

@injectable()
export class ToolsServiceImpl extends AbstractModel<ToolMenuItem[]> implements ToolsService {

    registerToolMenuItem(tool: ToolMenuItem) {
        if (this.modelData.find(t => t.id === tool.id)) {
            return Disposable.NULL;
        }
        this.update(data => [...data, this._normalizeTool(tool)]);

        const dispose = () => {
            this.update(data => data.filter(t => t.id !== tool.id));
        };

        return { dispose };
    }

    private _normalizeTool(tool: ToolMenuItem) {
        return {
            ...tool,
            order: tool.order || 0,
        };
    }

    protected _modelData = [];

    getToolMenuItems() {
        return this.modelData.sort((a, b) => a.order! - b.order!);
    }
}
